import { render, staticRenderFns } from "./GoogleCallback.vue?vue&type=template&id=399562ae&scoped=true"
import script from "./GoogleCallback.vue?vue&type=script&lang=js"
export * from "./GoogleCallback.vue?vue&type=script&lang=js"
import style0 from "./GoogleCallback.vue?vue&type=style&index=0&id=399562ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399562ae",
  null
  
)

export default component.exports